import React, { useEffect, useState } from "react";
import { Formik, Form} from "formik";
import { connect } from "react-redux";
import { fetchUser } from "../../../store/slices/user/index";
import {getIdpData,postIdpData} from '../../../store/slices/idp/index'
import Controler from "../idp-ug-pg/control";
import Loader from "../common/loader";
import ButtonLoader from "../common/buttonLoader";
const IdpVirtualFairForm = (props) => {  
    const [destination, setDestination] = useState(null)
    const [isFormSubmit, setIsFormSubmit] = useState(false)
    const [formikvalues,setFormikvalues] =useState([])
    const [areaInterest, setAreaInterest] = useState([])
    const [collegePan, setCollegePan] = useState([])
    const [collegeNonPan, setCollegeNonPan] = useState([])
    const [cloudTag, setCloudTag] = useState([])
    
    const [initialValues, setInitialValues] = useState({
      colleges_pan: [],
      colleges_non_pan: [],
      branches:[],
    })

    const d = new Date();
    const ms = d.getMilliseconds();

    useEffect(() => {
      props.dispatch(fetchUser());
    }, []);
    
    useEffect(() => {
      if(props.user?.data?.id){
        props.dispatch(getIdpData({uid: props.user?.data?.id, ms:ms}))
      }
      const gotToHomePage = window?.location?.origin;
      let desti
      if(!!window.location?.search?.includes('destination')) desti = window.location?.search?.replace("?destination=", "");
      else desti = 'https://www.careers360.com'
      setDestination(desti);

      if (!!props?.isUser?.user_error && !!destination)
        window.location.href = destination;
      else if (!!props?.isUser?.user_error && !destination)
        window.location.href = gotToHomePage;
      else if (!!props?.isUser?.user && !destination)
        window.location.href = gotToHomePage;
    }, [props?.isUser]);

    useEffect(()=>{
      if(!!destination && (props.idpData?.admission_preference_status == 2)){
        window.location.href =  destination
      }
      if(props.idpData?.idp?.length){
          //new code start here
          for(let item of props.idpData?.idp){
            if(item?.entity == "branches") setAreaInterest(item?.value)
            else if(item?.entity == "colleges_pan") setCollegePan(item?.value)
            else if(item?.entity == "colleges_non_pan") setCollegeNonPan(item?.value)
          }
          //new code end here
      }
    },[props.idpData])
    
    const onSubmit= () =>{
      let postData = {
        uid: props.user?.data?.id,
        admission_preference_status: 2,
        idp_type: props.idpData?.idp_type,
        idp_form_id: props.idpData?.idp_form_id,
        branches: formikvalues?.branches,
        colleges_pan: formikvalues?.colleges_pan,
        colleges_non_pan: formikvalues?.colleges_non_pan
      }
      
      setIsFormSubmit(true)
      props.dispatch(postIdpData(postData));
    }

    const validate = (values) =>{
      let error = {}
      if(!!areaInterest?.length && !values?.branches?.length) error.branches = 'This Field is required'
      if(!!collegePan?.length && !values?.colleges_pan?.length) error.colleges_pan = 'This Field is required'
      if(!!collegeNonPan?.length && !values?.colleges_non_pan?.length) error.colleges_non_pan = 'This Field is required'
      
      return error
    }
    useEffect(()=>{
      if(props.postRequest?.status){
        window.location.href =  destination
      }
    },[props.postRequest])

    useEffect(()=>{
      const filteredItems = areaInterest?.filter(item => formikvalues?.branches?.includes(`${item.id}`));
      setCloudTag(filteredItems)
    },[formikvalues?.branches])

    return (<>
        {!props.idpData?.idp?.length ? <Loader /> :
        <Formik 
          initialValues={initialValues}
          isInitialValid = {false}
          validateOnMount = {false}
          validate={validate} 
          // enableReinitialize={true} 
          onSubmit={onSubmit}
        >
          {({values, isValid, setFieldValue})=>{
            
            setTimeout(()=>{
              setFormikvalues(values)
            },10)
            const handleChange = (e,type) =>{
              
            }

          return (
            <Form>
              <div className="ug_pg_common_container">  
                <div className="idp_container_inner"> 
                
                <div className="idp_card checkbox_button">
                {!!areaInterest.length &&<>
                  <div className="heading_group">
                    <h3>Areas of Interest</h3>
                    <p className="para">Which Fields of Study Interest You?</p>
                    <p className="mandatory"><span>*</span> You can select up to 3 streams</p>
                  </div>
                  {!!cloudTag?.length &&
                    <div className="cloud_tags">
                      <Controler control="checkbox" handleChange={handleChange} formikValues={formikvalues?.users_state_colleges} options={cloudTag} name="branches" />
                    </div>
                  }
                  <Controler control="checkbox" max={formikvalues?.branches?.length > 2 ? true : false}  handleChange={handleChange} formikValues={formikvalues?.users_state_colleges} options={areaInterest} name="branches" questionName="" />
                </>}
                </div>

                <div className="idp_card checkbox_field">
                    <div className="heading_group card_head">
                      <h3>Choose Colleges of your choice</h3>
                      <p>Which colleges are you most interested in? We'll connect you directly for more information.</p>
                    </div>
                  {!!collegePan.length &&<>
                    <div className="heading_group text_left">
                      <h4>National Level Colleges</h4>
                      <p>We have curated a list of National Level colleges, which are currently accepting admissions</p>
                      <p className="mandatory"><span>*</span> You can select up to 3 colleges</p>
                    </div>
                    
                    <Controler control="checkbox" max={formikvalues?.colleges_pan?.length > 2 ? true : false}  handleChange={handleChange} formikValues={formikvalues?.users_state_colleges} options={collegePan} name="colleges_pan" questionName="" />
                  </>}

                  {!!collegeNonPan.length &&<>
                    <br/>
                    <br/>
                    <div className="heading_group text_left">
                      <h4>State Level Colleges</h4>
                      <p>Based on your current location, we have listed out colleges which are open for admissions in your state</p>
                      <p className="mandatory"><span>*</span> You can select up to 3 colleges</p>
                    </div>
                    
                    <Controler control="checkbox" max={formikvalues?.colleges_non_pan?.length > 2 ? true : false}  handleChange={handleChange} formikValues={formikvalues?.users_state_colleges} options={collegeNonPan} name="colleges_non_pan" questionName="" />
                  </>}
                </div>

                  <div className="submit_btn_blk">
                    {isFormSubmit ? <ButtonLoader/>:
                      <button className="submit_btn"
                      disabled={!isValid}
                      type="submit">Submit</button>
                    }
                  </div>
                </div>
              </div>
          </Form>
          )}}
        </Formik>
        }
    </>)
};

const mapStateToProps = (state) => {
  return {
    user: state.userData?.user,
    isUser: state.userData,
    idpData: state.idp?.getIdpSuccess?.data,
    postRequest:state.idp?.postIdpSuccess?.data
  };
};  

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IdpVirtualFairForm);